import { useState } from 'react';
import './App.css';

function App() {
  const [products, setProducts] = useState([]);
  const [showProducts, setShowProducts] = useState(false);
  const [loading, setLoading] = useState(false); // For loading state

  const getProductsFromServer = async () => {
    setLoading(true);
    const response = await fetch("https://fakestoreapi.com/products");
    const data = await response.json();
    setProducts(data);
    setShowProducts(true);
    setLoading(false);
  };

  const goBack = () => {
    setShowProducts(false);
    setProducts([]);
  };

  return (
    <div
      className="App"
      style={{
        backgroundColor: showProducts ? "red" : "lightblue",
        minHeight: "100vh",
        transition: "background-color 0.5s ease",
      }}
    >
      {!showProducts ? (
        <div className="start-screen">
          <h1 className="title">🛍️ Trendy Mart</h1>
          <p className="tagline">Your one-stop shop for everything trendy!</p>

          <button
            type="button"
            className="btn-primary"
            onClick={getProductsFromServer}
            disabled={loading}
          >
            {loading ? "Loading..." : "Get Products"}
          </button>
        </div>
      ) : (
        <>
          <h2 className="subtitle">Shop Smart for Fashion, Jewelry & Electronics</h2>

          <div className="mainContainer">
            {products.map((ele, i) => (
              <div key={i} className="productContainer">
                <img src={ele.image} alt={ele.title} title={ele.description} />
                <div className="productDetails">
                  <h3 className="productTitle">{ele.title}</h3>
                  <p className="category">{ele.category}</p>
                  <p className="price">₹{ele.price}</p>
                  <p className="rating">
                    {ele.rating?.rate} 🌟 | {ele.rating?.count} reviews
                  </p>
                </div>
              </div>
            ))}
          </div>

          <button
            type="button"
            className="btn-back"
            onClick={goBack}
          >
            🔙 Back
          </button>
          <br></br>
          <br></br>
        </>
      )}
    </div>
  );
}

export default App;
